import React, { useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, useStyles } from './styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
    Typography,
    Checkbox,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Button,
} from '@material-ui/core';

export default function ApplicationsTableMultiColumnFilter({
    column: { setFilter, preFilteredRows, id, render, filterValue },
}) {
    const classes = useStyles();

    const options = React.useMemo(() => {
        let counts = {};
        preFilteredRows.forEach(row => {
            if (!row.values[id]) return;

            row = row.values[id].toString();

            counts[row] = (counts[row] || 0) + 1;
        });
        return counts;
    }, [id, preFilteredRows]);

    const [checked, setChecked] = React.useState(Object.keys(options));

    useEffect(() => {
        if (!filterValue) {
            setChecked(Object.keys(options));
        }
    }, [filterValue]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const t = e.target.name.toString();

        if (checked && checked.includes(t)) {
            setFilter(checked.filter(v => v !== t));
            setChecked(prevChecked => {
                if (prevChecked.length === 1) return Object.keys(options);
                return prevChecked.filter(v => v !== t);
            });
        } else {
            setFilter([...checked, t]);
            setChecked(prevChecked => [...prevChecked, t]);
        }
    };

    return (
        <Accordion square>
            <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={<ExpandMoreIcon />}
            >
                <Typography>{render('Header')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <List dense className={classes.list}>
                    <Button
                        className={classes.button}
                        onClick={() => {
                            setChecked(Object.keys(options));
                            setFilter([]);
                        }}
                    >
                        Select All
                    </Button>

                    {Object.entries(options).map(([option, count], i) => (
                        <ListItem key={`list-item-${option}-${i}`}>
                            <ListItemText id={option} primary={`${option} (${count})`} />
                            <ListItemSecondaryAction>
                                <Checkbox
                                    name={option}
                                    color="primary"
                                    id={option}
                                    checked={checked.includes(option)}
                                    onChange={onChange}
                                    inputProps={{ 'aria-labelledby': option }}
                                    edge="end"
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </AccordionDetails>
        </Accordion>
    );
}
